import React from "react";
import { cn } from "../../utils/cn";

export default function Hero({
    title,
    subtitle,
    primaryCta,
    secondaryCta,
    badges,
}: {
    title: string;
    subtitle: string;
    primaryCta: { label: string; href: string };
    secondaryCta: { label: string; href: string };
    badges: string[];
}) {
    return (
        <section className="relative">
            <div className="mx-auto grid max-w-6xl items-center gap-10 px-4 py-16 sm:px-6 sm:py-20 lg:grid-cols-2">
                <div>
                    <div className="inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/70">
                        <span className="h-2 w-2 rounded-full bg-white/60" />
                        Panel + bot w jednym ekosystemie
                    </div>

                    <h1 className="mt-5 text-balance text-3xl font-semibold tracking-tight text-white sm:text-5xl">
                        {title}
                    </h1>
                    <p className="mt-4 text-pretty text-sm text-white/70 sm:text-base">{subtitle}</p>

                    <div className="mt-7 flex flex-col gap-3 sm:flex-row">
                        <a
                            href={primaryCta.href}
                            className="rounded-2xl bg-white px-5 py-3 text-sm font-medium text-black hover:bg-white/90 transition text-center"
                        >
                            {primaryCta.label}
                        </a>
                        <a
                            href={secondaryCta.href}
                            className="rounded-2xl border border-white/10 bg-white/5 px-5 py-3 text-sm text-white/80 hover:bg-white/10 transition text-center"
                        >
                            {secondaryCta.label}
                        </a>
                    </div>

                    <div className="mt-6 flex flex-wrap gap-2">
                        {badges.map((b) => (
                            <span
                                key={b}
                                className="rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs text-white/70"
                            >
                                {b}
                            </span>
                        ))}
                    </div>
                </div>

                {/* Mock "Discord preview" */}
                <div className="relative">
                    <div className="rounded-3xl border border-white/10 bg-white/5 p-4 shadow-2xl backdrop-blur">
                        <div className="flex items-center justify-between">
                            <div className="text-xs text-white/60">Podgląd komend</div>
                            <div className="flex gap-1">
                                <span className="h-2 w-2 rounded-full bg-white/30" />
                                <span className="h-2 w-2 rounded-full bg-white/30" />
                                <span className="h-2 w-2 rounded-full bg-white/30" />
                            </div>
                        </div>

                        <div className="mt-3 space-y-2">
                            {[
                                { cmd: "/ban @user", label: "Szybkie bany i timeouty" },
                                { cmd: "/ticket create", label: "Zgłoszenia i support" },
                                { cmd: "/autorole set", label: "Automatyczne role" },
                                { cmd: "/level rank", label: "Leveling i nagrody" },
                            ].map((row) => (
                                <div
                                    key={row.cmd}
                                    className={cn(
                                        "rounded-2xl border border-white/10 bg-black/20 px-4 py-3",
                                        "flex items-center justify-between gap-3"
                                    )}
                                >
                                    <div className="text-sm font-medium text-white">{row.cmd}</div>
                                    <div className="text-xs text-white/60">{row.label}</div>
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className="absolute -right-6 -top-6 h-20 w-20 rounded-full bg-white/10 blur-2xl" />
                    <div className="absolute -left-10 -bottom-10 h-28 w-28 rounded-full bg-white/5 blur-2xl" />
                </div>
            </div>
        </section>
    );
}
